// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.1.0 (commit 6981f48b4bc1a71c8dd9bdfe5a2c343f6370243d).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AbandonArenaMatchReducer from "./abandon_arena_match_reducer";
import AcquireGlobalWorldReducer from "./acquire_global_world_reducer";
import AddBotToMatchReducer from "./add_bot_to_match_reducer";
import ArenaMatchmakingTimeoutReducer from "./arena_matchmaking_timeout_reducer";
import AweAckCommandsReducer from "./awe_ack_commands_reducer";
import AweClaimArmyReducer from "./awe_claim_army_reducer";
import AweCloseCampaignReducer from "./awe_close_campaign_reducer";
import AweCreateCampaignReducer from "./awe_create_campaign_reducer";
import AweDeleteCampaignReducer from "./awe_delete_campaign_reducer";
import AweDeployArmyReducer from "./awe_deploy_army_reducer";
import AweJoinGrantReducer from "./awe_join_grant_reducer";
import AweOrderArmyReducer from "./awe_order_army_reducer";
import AweSetHostReducer from "./awe_set_host_reducer";
import AweSetSteamLobbyReducer from "./awe_set_steam_lobby_reducer";
import AweUpdateRulesReducer from "./awe_update_rules_reducer";
import CancelMessengerReducer from "./cancel_messenger_reducer";
import CancelWallBuildProjectReducer from "./cancel_wall_build_project_reducer";
import ChooseConquestStarterReducer from "./choose_conquest_starter_reducer";
import ClaimMatchHostReducer from "./claim_match_host_reducer";
import ClaimOrchestratorIdentityReducer from "./claim_orchestrator_identity_reducer";
import ClaimRecruitedUnitsReducer from "./claim_recruited_units_reducer";
import CleanupStaleLobbiesReducer from "./cleanup_stale_lobbies_reducer";
import ClearAuthReducer from "./clear_auth_reducer";
import CommitGlobalWorldReducer from "./commit_global_world_reducer";
import CreateConquestCustomUnitTemplateReducer from "./create_conquest_custom_unit_template_reducer";
import CreateGlobalStarterRosterReducer from "./create_global_starter_roster_reducer";
import CreateMatchReducer from "./create_match_reducer";
import DeleteConquestCustomUnitTemplateReducer from "./delete_conquest_custom_unit_template_reducer";
import DeleteFormationReducer from "./delete_formation_reducer";
import DeleteGroupReducer from "./delete_group_reducer";
import DeleteMapReducer from "./delete_map_reducer";
import DeployGlobalArmyReducer from "./deploy_global_army_reducer";
import DeployGlobalStarterReducer from "./deploy_global_starter_reducer";
import DeployUnitsReducer from "./deploy_units_reducer";
import DesignateHarvestTileReducer from "./designate_harvest_tile_reducer";
import DispatchOrderReducer from "./dispatch_order_reducer";
import EnterArenaQueueReducer from "./enter_arena_queue_reducer";
import ExpireGlobalLeaseReducer from "./expire_global_lease_reducer";
import FormUpReducer from "./form_up_reducer";
import GroupOrderReducer from "./group_order_reducer";
import JoinCampaignWorldReducer from "./join_campaign_world_reducer";
import JoinConquestReducer from "./join_conquest_reducer";
import JoinConquestQueueReducer from "./join_conquest_queue_reducer";
import JoinGlobalWorldReducer from "./join_global_world_reducer";
import JoinMatchReducer from "./join_match_reducer";
import LeaveArenaQueueReducer from "./leave_arena_queue_reducer";
import LeaveConquestQueueReducer from "./leave_conquest_queue_reducer";
import LeaveMatchReducer from "./leave_match_reducer";
import OrderFollowReducer from "./order_follow_reducer";
import OrderGlobalUnitsReducer from "./order_global_units_reducer";
import PresentAuthTokenReducer from "./present_auth_token_reducer";
import ProcessCampaignTickReducer from "./process_campaign_tick_reducer";
import ProcessConquestLobbyTimerReducer from "./process_conquest_lobby_timer_reducer";
import ProcessTickReducer from "./process_tick_reducer";
import QueueOrdersReducer from "./queue_orders_reducer";
import ReadyReducer from "./ready_reducer";
import RecruitCampaignUnitsReducer from "./recruit_campaign_units_reducer";
import RegisterGlobalCampaignReducer from "./register_global_campaign_reducer";
import RegisterMapReducer from "./register_map_reducer";
import RegisterMapChunkReducer from "./register_map_chunk_reducer";
import RegisterMatchWorkerReducer from "./register_match_worker_reducer";
import RenewGlobalWorldReducer from "./renew_global_world_reducer";
import ResetConquestCustomUnitTemplateReducer from "./reset_conquest_custom_unit_template_reducer";
import SaveConquestBattleUnitsReducer from "./save_conquest_battle_units_reducer";
import SaveConquestCustomUnitTemplateReducer from "./save_conquest_custom_unit_template_reducer";
import SaveFormationReducer from "./save_formation_reducer";
import SaveMarchOrderReducer from "./save_march_order_reducer";
import SelectRosterReducer from "./select_roster_reducer";
import SetArmyColorReducer from "./set_army_color_reducer";
import SetArmyCultureReducer from "./set_army_culture_reducer";
import SetCampaignArmyDestinationReducer from "./set_campaign_army_destination_reducer";
import SetConquestArmyBannerReducer from "./set_conquest_army_banner_reducer";
import SetConquestArmyMarkerReducer from "./set_conquest_army_marker_reducer";
import SetConquestCultureReducer from "./set_conquest_culture_reducer";
import SetFormationShapeReducer from "./set_formation_shape_reducer";
import SetGroupReducer from "./set_group_reducer";
import SetMapActiveReducer from "./set_map_active_reducer";
import SetNameReducer from "./set_name_reducer";
import SetOrchestratorIdentityReducer from "./set_orchestrator_identity_reducer";
import SetSimulationDisabledReducer from "./set_simulation_disabled_reducer";
import StartMatchReducer from "./start_match_reducer";
import SubmitMatchResultReducer from "./submit_match_result_reducer";
import TestStartMatchReducer from "./test_start_match_reducer";
import ToggleGateReducer from "./toggle_gate_reducer";
import UndesignateHarvestTileReducer from "./undesignate_harvest_tile_reducer";
import UpdateConquestCustomUnitTemplateReducer from "./update_conquest_custom_unit_template_reducer";
import UpdateFormationReducer from "./update_formation_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import ArenaMatchmakingLobbiesRow from "./arena_matchmaking_lobbies_table";
import ArenaMatchmakingLobbyPlayersRow from "./arena_matchmaking_lobby_players_table";
import ArenaMatchmakingQueueRow from "./arena_matchmaking_queue_table";
import ArenaMatchmakingTimerScheduleRow from "./arena_matchmaking_timer_schedule_table";
import ArmiesRow from "./armies_table";
import ArmyFormationsRow from "./army_formations_table";
import ArmyGroupsRow from "./army_groups_table";
import ArmyUnitsRow from "./army_units_table";
import AuthCacheRow from "./auth_cache_table";
import AweArmiesRow from "./awe_armies_table";
import AweCampaignsRow from "./awe_campaigns_table";
import AweHostCommandsRow from "./awe_host_commands_table";
import AweHostFactionsRow from "./awe_host_factions_table";
import AweHostTerritoryRow from "./awe_host_territory_table";
import AweHostWorldRow from "./awe_host_world_table";
import AweHostsRow from "./awe_hosts_table";
import AweRulesRow from "./awe_rules_table";
import CampaignArmiesRow from "./campaign_armies_table";
import CampaignBattlesRow from "./campaign_battles_table";
import CampaignCitiesRow from "./campaign_cities_table";
import CampaignCountiesRow from "./campaign_counties_table";
import CampaignEventsRow from "./campaign_events_table";
import CampaignPlayersRow from "./campaign_players_table";
import CampaignRecruitmentQueueRow from "./campaign_recruitment_queue_table";
import CampaignResourcePoolsRow from "./campaign_resource_pools_table";
import CampaignStrategicResourcesRow from "./campaign_strategic_resources_table";
import CampaignTickScheduleRow from "./campaign_tick_schedule_table";
import CampaignWorldsRow from "./campaign_worlds_table";
import ConnectionsRow from "./connections_table";
import ConquestChallengesRow from "./conquest_challenges_table";
import ConquestCustomUnitTemplatesRow from "./conquest_custom_unit_templates_table";
import ConquestEventsRow from "./conquest_events_table";
import ConquestLobbyTimerScheduleRow from "./conquest_lobby_timer_schedule_table";
import ConquestLobbyTimersRow from "./conquest_lobby_timers_table";
import ConquestMatchmakingQueueRow from "./conquest_matchmaking_queue_table";
import ConquestProfilesRow from "./conquest_profiles_table";
import ConquestSavedUnitsRow from "./conquest_saved_units_table";
import ConquestTerritoriesRow from "./conquest_territories_table";
import GlobalCitiesRow from "./global_cities_table";
import GlobalCommandsRow from "./global_commands_table";
import GlobalFactionsRow from "./global_factions_table";
import GlobalLeaseChecksRow from "./global_lease_checks_table";
import GlobalResultsRow from "./global_results_table";
import GlobalTerritoryRow from "./global_territory_table";
import GlobalWorldRow from "./global_world_table";
import GlobalWorldStatusRow from "./global_world_status_table";
import LobbyCleanupScheduleRow from "./lobby_cleanup_schedule_table";
import MapDataRow from "./map_data_table";
import MapUploadBufferRow from "./map_upload_buffer_table";
import MatchAntGroupsRow from "./match_ant_groups_table";
import MatchArmiesRow from "./match_armies_table";
import MatchCampsRow from "./match_camps_table";
import MatchCapturePointsRow from "./match_capture_points_table";
import MatchCheckpointsRow from "./match_checkpoints_table";
import MatchEconomyRow from "./match_economy_table";
import MatchEngagementsRow from "./match_engagements_table";
import MatchEventsRow from "./match_events_table";
import MatchHandoffRequestsRow from "./match_handoff_requests_table";
import MatchHostRow from "./match_host_table";
import MatchMessengersRow from "./match_messengers_table";
import MatchProjectilesRow from "./match_projectiles_table";
import MatchStateRow from "./match_state_table";
import MatchStructureStateRow from "./match_structure_state_table";
import MatchTerrainOverridesRow from "./match_terrain_overrides_table";
import MatchUnitsRow from "./match_units_table";
import MatchWallBuildProjectsRow from "./match_wall_build_projects_table";
import MatchWorkerEndpointsRow from "./match_worker_endpoints_table";
import MatchesRow from "./matches_table";
import ModuleAdminRow from "./module_admin_table";
import ModuleRuntimeConfigRow from "./module_runtime_config_table";
import MyArmiesRow from "./my_armies_table";
import MyArmyFormationsRow from "./my_army_formations_table";
import MyArmyGroupsRow from "./my_army_groups_table";
import MyArmyUnitsRow from "./my_army_units_table";
import MyCampaignArmyRow from "./my_campaign_army_table";
import MyCampaignPlayerRow from "./my_campaign_player_table";
import MyCampaignRecruitmentRow from "./my_campaign_recruitment_table";
import MyCampaignResourcesRow from "./my_campaign_resources_table";
import MyConquestChallengesRow from "./my_conquest_challenges_table";
import MyConquestCustomUnitTemplatesRow from "./my_conquest_custom_unit_templates_table";
import MyConquestEventsRow from "./my_conquest_events_table";
import MyConquestProfilesRow from "./my_conquest_profiles_table";
import MyConquestProfilesV2Row from "./my_conquest_profiles_v_2_table";
import MyConquestQueueRow from "./my_conquest_queue_table";
import MyConquestSavedUnitsRow from "./my_conquest_saved_units_table";
import MyConquestTerritoriesRow from "./my_conquest_territories_table";
import MyEnemyUnitsRow from "./my_enemy_units_table";
import MyEngagementsRow from "./my_engagements_table";
import MyFriendlyUnitsRow from "./my_friendly_units_table";
import MyGlobalFactionRow from "./my_global_faction_table";
import MyGlobalResultsRow from "./my_global_results_table";
import MyGlobalRostersRow from "./my_global_rosters_table";
import MyMatchFollowWaypointsRow from "./my_match_follow_waypoints_table";
import MyMatchMetaRow from "./my_match_meta_table";
import MyMatchRoadsRow from "./my_match_roads_table";
import MyMatchWorkerEndpointRow from "./my_match_worker_endpoint_table";
import MyMessengersRow from "./my_messengers_table";
import MyProjectilesRow from "./my_projectiles_table";
import MySessionRow from "./my_session_table";
import MyStandaloneStartPacketRow from "./my_standalone_start_packet_table";
import MyUnitOrderQueueRow from "./my_unit_order_queue_table";
import MyUnitPathWaypointsRow from "./my_unit_path_waypoints_table";
import MyUnitSkillsRow from "./my_unit_skills_table";
import MyVisibilityBitmapRow from "./my_visibility_bitmap_table";
import OrchestratorIdentityRow from "./orchestrator_identity_table";
import PendingOrdersRow from "./pending_orders_table";
import PlayerMatchFollowWaypointsRow from "./player_match_follow_waypoints_table";
import PlayerMatchMetaRow from "./player_match_meta_table";
import PlayerMatchRoadsRow from "./player_match_roads_table";
import PlayerVisibilityBitmapsRow from "./player_visibility_bitmaps_table";
import PlayerVisibleEnemyUnitsRow from "./player_visible_enemy_units_table";
import PlayerVisibleEngagementsRow from "./player_visible_engagements_table";
import PlayerVisibleFriendlyUnitsRow from "./player_visible_friendly_units_table";
import PlayerVisibleMessengersRow from "./player_visible_messengers_table";
import PlayerVisibleProjectilesRow from "./player_visible_projectiles_table";
import PlayerVisibleProjectilesV2Row from "./player_visible_projectiles_v_2_table";
import PlayerVisibleProjectilesV3Row from "./player_visible_projectiles_v_3_table";
import PlayerVisibleUnitOrderQueueRow from "./player_visible_unit_order_queue_table";
import PlayerVisibleUnitPathWaypointsRow from "./player_visible_unit_path_waypoints_table";
import PlayerVisibleUnitSkillsRow from "./player_visible_unit_skills_table";
import PlayersRow from "./players_table";
import SkirmishLobbyMatchesRow from "./skirmish_lobby_matches_table";
import StandaloneStartPacketsRow from "./standalone_start_packets_table";
import TickScheduleRow from "./tick_schedule_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  arena_matchmaking_lobbies: __table({
    name: 'arena_matchmaking_lobbies',
    indexes: [
      { accessor: 'lobby_id', name: 'arena_matchmaking_lobbies_lobby_id_idx_btree', algorithm: 'btree', columns: [
        'lobbyId',
      ] },
    ],
    constraints: [
      { name: 'arena_matchmaking_lobbies_lobby_id_key', constraint: 'unique', columns: ['lobbyId'] },
    ],
  }, ArenaMatchmakingLobbiesRow),
  arena_matchmaking_lobby_players: __table({
    name: 'arena_matchmaking_lobby_players',
    indexes: [
      { accessor: 'player_id', name: 'arena_matchmaking_lobby_players_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
    ],
    constraints: [
      { name: 'arena_matchmaking_lobby_players_player_id_key', constraint: 'unique', columns: ['playerId'] },
    ],
  }, ArenaMatchmakingLobbyPlayersRow),
  arena_matchmaking_queue: __table({
    name: 'arena_matchmaking_queue',
    indexes: [
      { accessor: 'player_id', name: 'arena_matchmaking_queue_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
    ],
    constraints: [
      { name: 'arena_matchmaking_queue_player_id_key', constraint: 'unique', columns: ['playerId'] },
    ],
  }, ArenaMatchmakingQueueRow),
  arena_matchmaking_timer_schedule: __table({
    name: 'arena_matchmaking_timer_schedule',
    indexes: [
      { accessor: 'scheduled_id', name: 'arena_matchmaking_timer_schedule_scheduled_id_idx_btree', algorithm: 'btree', columns: [
        'scheduledId',
      ] },
    ],
    constraints: [
      { name: 'arena_matchmaking_timer_schedule_scheduled_id_key', constraint: 'unique', columns: ['scheduledId'] },
    ],
  }, ArenaMatchmakingTimerScheduleRow),
  armies: __table({
    name: 'armies',
    indexes: [
      { accessor: 'id', name: 'armies_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'player_id', name: 'armies_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
    ],
    constraints: [
      { name: 'armies_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ArmiesRow),
  army_formations: __table({
    name: 'army_formations',
    indexes: [
      { accessor: 'army_id', name: 'army_formations_army_id_idx_btree', algorithm: 'btree', columns: [
        'armyId',
      ] },
      { accessor: 'id', name: 'army_formations_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'army_formations_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ArmyFormationsRow),
  army_groups: __table({
    name: 'army_groups',
    indexes: [
      { accessor: 'army_id', name: 'army_groups_army_id_idx_btree', algorithm: 'btree', columns: [
        'armyId',
      ] },
      { accessor: 'id', name: 'army_groups_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'army_groups_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ArmyGroupsRow),
  army_units: __table({
    name: 'army_units',
    indexes: [
      { accessor: 'army_id', name: 'army_units_army_id_idx_btree', algorithm: 'btree', columns: [
        'armyId',
      ] },
      { accessor: 'id', name: 'army_units_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'army_units_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ArmyUnitsRow),
  auth_cache: __table({
    name: 'auth_cache',
    indexes: [
      { accessor: 'identity', name: 'auth_cache_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'user_id', name: 'auth_cache_user_id_idx_btree', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'auth_cache_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, AuthCacheRow),
  awe_armies: __table({
    name: 'awe_armies',
    indexes: [
      { accessor: 'campaign_id', name: 'awe_armies_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'id', name: 'awe_armies_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner_user_id', name: 'awe_armies_owner_user_id_idx_btree', algorithm: 'btree', columns: [
        'ownerUserId',
      ] },
    ],
    constraints: [
      { name: 'awe_armies_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AweArmiesRow),
  awe_campaigns: __table({
    name: 'awe_campaigns',
    indexes: [
      { accessor: 'gm_user_id', name: 'awe_campaigns_gm_user_id_idx_btree', algorithm: 'btree', columns: [
        'gmUserId',
      ] },
      { accessor: 'id', name: 'awe_campaigns_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'awe_campaigns_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AweCampaignsRow),
  awe_hosts: __table({
    name: 'awe_hosts',
    indexes: [
      { accessor: 'campaign_id', name: 'awe_hosts_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'identity', name: 'awe_hosts_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'awe_hosts_campaign_id_key', constraint: 'unique', columns: ['campaignId'] },
    ],
  }, AweHostsRow),
  awe_rules: __table({
    name: 'awe_rules',
    indexes: [
      { accessor: 'campaign_id', name: 'awe_rules_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
    ],
    constraints: [
      { name: 'awe_rules_campaign_id_key', constraint: 'unique', columns: ['campaignId'] },
    ],
  }, AweRulesRow),
  campaign_armies: __table({
    name: 'campaign_armies',
    indexes: [
      { accessor: 'id', name: 'campaign_armies_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'player_id', name: 'campaign_armies_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
    ],
    constraints: [
      { name: 'campaign_armies_id_key', constraint: 'unique', columns: ['id'] },
      { name: 'campaign_armies_player_id_key', constraint: 'unique', columns: ['playerId'] },
    ],
  }, CampaignArmiesRow),
  campaign_battles: __table({
    name: 'campaign_battles',
    indexes: [
      { accessor: 'id', name: 'campaign_battles_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'campaign_battles_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, CampaignBattlesRow),
  campaign_cities: __table({
    name: 'campaign_cities',
    indexes: [
      { accessor: 'id', name: 'campaign_cities_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner_player_id', name: 'campaign_cities_owner_player_id_idx_btree', algorithm: 'btree', columns: [
        'ownerPlayerId',
      ] },
    ],
    constraints: [
      { name: 'campaign_cities_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, CampaignCitiesRow),
  campaign_counties: __table({
    name: 'campaign_counties',
    indexes: [
      { accessor: 'key', name: 'campaign_counties_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
      { accessor: 'world_id', name: 'campaign_counties_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'campaign_counties_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, CampaignCountiesRow),
  campaign_events: __table({
    name: 'campaign_events',
    indexes: [
      { accessor: 'row_id', name: 'campaign_events_row_id_idx_btree', algorithm: 'btree', columns: [
        'rowId',
      ] },
    ],
    constraints: [
      { name: 'campaign_events_row_id_key', constraint: 'unique', columns: ['rowId'] },
    ],
  }, CampaignEventsRow),
  campaign_players: __table({
    name: 'campaign_players',
    indexes: [
      { accessor: 'player_id', name: 'campaign_players_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
    ],
    constraints: [
      { name: 'campaign_players_player_id_key', constraint: 'unique', columns: ['playerId'] },
    ],
  }, CampaignPlayersRow),
  campaign_recruitment_queue: __table({
    name: 'campaign_recruitment_queue',
    indexes: [
      { accessor: 'city_id', name: 'campaign_recruitment_queue_city_id_idx_btree', algorithm: 'btree', columns: [
        'cityId',
      ] },
      { accessor: 'player_id', name: 'campaign_recruitment_queue_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'row_id', name: 'campaign_recruitment_queue_row_id_idx_btree', algorithm: 'btree', columns: [
        'rowId',
      ] },
    ],
    constraints: [
      { name: 'campaign_recruitment_queue_row_id_key', constraint: 'unique', columns: ['rowId'] },
    ],
  }, CampaignRecruitmentQueueRow),
  campaign_resource_pools: __table({
    name: 'campaign_resource_pools',
    indexes: [
      { accessor: 'player_id', name: 'campaign_resource_pools_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
    ],
    constraints: [
      { name: 'campaign_resource_pools_player_id_key', constraint: 'unique', columns: ['playerId'] },
    ],
  }, CampaignResourcePoolsRow),
  campaign_strategic_resources: __table({
    name: 'campaign_strategic_resources',
    indexes: [
      { accessor: 'id', name: 'campaign_strategic_resources_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'player_id', name: 'campaign_strategic_resources_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'world_id', name: 'campaign_strategic_resources_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'campaign_strategic_resources_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, CampaignStrategicResourcesRow),
  campaign_tick_schedule: __table({
    name: 'campaign_tick_schedule',
    indexes: [
      { accessor: 'scheduled_id', name: 'campaign_tick_schedule_scheduled_id_idx_btree', algorithm: 'btree', columns: [
        'scheduledId',
      ] },
    ],
    constraints: [
      { name: 'campaign_tick_schedule_scheduled_id_key', constraint: 'unique', columns: ['scheduledId'] },
    ],
  }, CampaignTickScheduleRow),
  campaign_worlds: __table({
    name: 'campaign_worlds',
    indexes: [
      { accessor: 'id', name: 'campaign_worlds_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'campaign_worlds_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, CampaignWorldsRow),
  connections: __table({
    name: 'connections',
    indexes: [
      { accessor: 'identity', name: 'connections_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'connections_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, ConnectionsRow),
  conquest_challenges: __table({
    name: 'conquest_challenges',
    indexes: [
      { accessor: 'challenger_player_id', name: 'conquest_challenges_challenger_player_id_idx_btree', algorithm: 'btree', columns: [
        'challengerPlayerId',
      ] },
      { accessor: 'defender_player_id', name: 'conquest_challenges_defender_player_id_idx_btree', algorithm: 'btree', columns: [
        'defenderPlayerId',
      ] },
      { accessor: 'id', name: 'conquest_challenges_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'ruleset', name: 'conquest_challenges_ruleset_idx_btree', algorithm: 'btree', columns: [
        'ruleset',
      ] },
      { accessor: 'territory_id', name: 'conquest_challenges_territory_id_idx_btree', algorithm: 'btree', columns: [
        'territoryId',
      ] },
    ],
    constraints: [
      { name: 'conquest_challenges_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ConquestChallengesRow),
  conquest_custom_unit_templates: __table({
    name: 'conquest_custom_unit_templates',
    indexes: [
      { accessor: 'id', name: 'conquest_custom_unit_templates_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'player_id', name: 'conquest_custom_unit_templates_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'ruleset', name: 'conquest_custom_unit_templates_ruleset_idx_btree', algorithm: 'btree', columns: [
        'ruleset',
      ] },
    ],
    constraints: [
      { name: 'conquest_custom_unit_templates_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ConquestCustomUnitTemplatesRow),
  conquest_events: __table({
    name: 'conquest_events',
    indexes: [
      { accessor: 'player_id', name: 'conquest_events_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'row_id', name: 'conquest_events_row_id_idx_btree', algorithm: 'btree', columns: [
        'rowId',
      ] },
    ],
    constraints: [
      { name: 'conquest_events_row_id_key', constraint: 'unique', columns: ['rowId'] },
    ],
  }, ConquestEventsRow),
  conquest_lobby_timer_schedule: __table({
    name: 'conquest_lobby_timer_schedule',
    indexes: [
      { accessor: 'scheduled_id', name: 'conquest_lobby_timer_schedule_scheduled_id_idx_btree', algorithm: 'btree', columns: [
        'scheduledId',
      ] },
    ],
    constraints: [
      { name: 'conquest_lobby_timer_schedule_scheduled_id_key', constraint: 'unique', columns: ['scheduledId'] },
    ],
  }, ConquestLobbyTimerScheduleRow),
  conquest_lobby_timers: __table({
    name: 'conquest_lobby_timers',
    indexes: [
      { accessor: 'match_id', name: 'conquest_lobby_timers_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'conquest_lobby_timers_match_id_key', constraint: 'unique', columns: ['matchId'] },
    ],
  }, ConquestLobbyTimersRow),
  conquest_matchmaking_queue: __table({
    name: 'conquest_matchmaking_queue',
    indexes: [
      { accessor: 'player_id', name: 'conquest_matchmaking_queue_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'row_id', name: 'conquest_matchmaking_queue_row_id_idx_btree', algorithm: 'btree', columns: [
        'rowId',
      ] },
      { accessor: 'ruleset', name: 'conquest_matchmaking_queue_ruleset_idx_btree', algorithm: 'btree', columns: [
        'ruleset',
      ] },
      { accessor: 'territory_id', name: 'conquest_matchmaking_queue_territory_id_idx_btree', algorithm: 'btree', columns: [
        'territoryId',
      ] },
    ],
    constraints: [
      { name: 'conquest_matchmaking_queue_row_id_key', constraint: 'unique', columns: ['rowId'] },
    ],
  }, ConquestMatchmakingQueueRow),
  conquest_profiles: __table({
    name: 'conquest_profiles',
    indexes: [
      { accessor: 'id', name: 'conquest_profiles_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'player_id', name: 'conquest_profiles_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'ruleset', name: 'conquest_profiles_ruleset_idx_btree', algorithm: 'btree', columns: [
        'ruleset',
      ] },
    ],
    constraints: [
      { name: 'conquest_profiles_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ConquestProfilesRow),
  conquest_saved_units: __table({
    name: 'conquest_saved_units',
    indexes: [
      { accessor: 'id', name: 'conquest_saved_units_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'player_id', name: 'conquest_saved_units_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'ruleset', name: 'conquest_saved_units_ruleset_idx_btree', algorithm: 'btree', columns: [
        'ruleset',
      ] },
    ],
    constraints: [
      { name: 'conquest_saved_units_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ConquestSavedUnitsRow),
  conquest_territories: __table({
    name: 'conquest_territories',
    indexes: [
      { accessor: 'id', name: 'conquest_territories_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'player_id', name: 'conquest_territories_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'ruleset', name: 'conquest_territories_ruleset_idx_btree', algorithm: 'btree', columns: [
        'ruleset',
      ] },
      { accessor: 'territory_id', name: 'conquest_territories_territory_id_idx_btree', algorithm: 'btree', columns: [
        'territoryId',
      ] },
    ],
    constraints: [
      { name: 'conquest_territories_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ConquestTerritoriesRow),
  global_cities: __table({
    name: 'global_cities',
    indexes: [
      { accessor: 'campaign_id', name: 'global_cities_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'founder_id', name: 'global_cities_founder_id_idx_btree', algorithm: 'btree', columns: [
        'founderId',
      ] },
      { accessor: 'id', name: 'global_cities_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner', name: 'global_cities_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'global_cities_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GlobalCitiesRow),
  global_commands: __table({
    name: 'global_commands',
    indexes: [
      { accessor: 'campaign_id', name: 'global_commands_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'faction_id', name: 'global_commands_faction_id_idx_btree', algorithm: 'btree', columns: [
        'factionId',
      ] },
      { accessor: 'id', name: 'global_commands_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'global_commands_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GlobalCommandsRow),
  global_factions: __table({
    name: 'global_factions',
    indexes: [
      { accessor: 'account_id', name: 'global_factions_account_id_idx_btree', algorithm: 'btree', columns: [
        'accountId',
      ] },
      { accessor: 'campaign_id', name: 'global_factions_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'id', name: 'global_factions_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'global_factions_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GlobalFactionsRow),
  global_lease_checks: __table({
    name: 'global_lease_checks',
    indexes: [
      { accessor: 'campaign_id', name: 'global_lease_checks_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'scheduled_id', name: 'global_lease_checks_scheduled_id_idx_btree', algorithm: 'btree', columns: [
        'scheduledId',
      ] },
    ],
    constraints: [
      { name: 'global_lease_checks_scheduled_id_key', constraint: 'unique', columns: ['scheduledId'] },
    ],
  }, GlobalLeaseChecksRow),
  global_results: __table({
    name: 'global_results',
    indexes: [
      { accessor: 'faction_id', name: 'global_results_faction_id_idx_btree', algorithm: 'btree', columns: [
        'factionId',
      ] },
      { accessor: 'key', name: 'global_results_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'global_results_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, GlobalResultsRow),
  global_territory: __table({
    name: 'global_territory',
    indexes: [
      { accessor: 'campaign_id', name: 'global_territory_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
    ],
    constraints: [
      { name: 'global_territory_campaign_id_key', constraint: 'unique', columns: ['campaignId'] },
    ],
  }, GlobalTerritoryRow),
  global_world: __table({
    name: 'global_world',
    indexes: [
      { accessor: 'catalog', name: 'global_world_catalog_idx_btree', algorithm: 'btree', columns: [
        'catalog',
      ] },
      { accessor: 'id', name: 'global_world_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'global_world_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GlobalWorldRow),
  lobby_cleanup_schedule: __table({
    name: 'lobby_cleanup_schedule',
    indexes: [
      { accessor: 'scheduled_id', name: 'lobby_cleanup_schedule_scheduled_id_idx_btree', algorithm: 'btree', columns: [
        'scheduledId',
      ] },
    ],
    constraints: [
      { name: 'lobby_cleanup_schedule_scheduled_id_key', constraint: 'unique', columns: ['scheduledId'] },
    ],
  }, LobbyCleanupScheduleRow),
  map_data: __table({
    name: 'map_data',
    indexes: [
      { accessor: 'name', name: 'map_data_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
    ],
    constraints: [
      { name: 'map_data_name_key', constraint: 'unique', columns: ['name'] },
    ],
  }, MapDataRow),
  map_upload_buffer: __table({
    name: 'map_upload_buffer',
    indexes: [
      { accessor: 'name', name: 'map_upload_buffer_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
    ],
    constraints: [
      { name: 'map_upload_buffer_name_key', constraint: 'unique', columns: ['name'] },
    ],
  }, MapUploadBufferRow),
  match_ant_groups: __table({
    name: 'match_ant_groups',
    indexes: [
      { accessor: 'match_id', name: 'match_ant_groups_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_ant_groups_match_id_key', constraint: 'unique', columns: ['matchId'] },
    ],
  }, MatchAntGroupsRow),
  match_armies: __table({
    name: 'match_armies',
    indexes: [
      { accessor: 'claimed_player_id', name: 'match_armies_claimed_player_id_idx_btree', algorithm: 'btree', columns: [
        'claimedPlayerId',
      ] },
      { accessor: 'match_id', name: 'match_armies_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'match_armies_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'row_id', name: 'match_armies_row_id_idx_btree', algorithm: 'btree', columns: [
        'rowId',
      ] },
    ],
    constraints: [
      { name: 'match_armies_row_id_key', constraint: 'unique', columns: ['rowId'] },
    ],
  }, MatchArmiesRow),
  match_camps: __table({
    name: 'match_camps',
    indexes: [
      { accessor: 'camp_id', name: 'match_camps_camp_id_idx_btree', algorithm: 'btree', columns: [
        'campId',
      ] },
      { accessor: 'match_id', name: 'match_camps_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_camps_camp_id_key', constraint: 'unique', columns: ['campId'] },
    ],
  }, MatchCampsRow),
  match_capture_points: __table({
    name: 'match_capture_points',
    indexes: [
      { accessor: 'capture_point_id', name: 'match_capture_points_capture_point_id_idx_btree', algorithm: 'btree', columns: [
        'capturePointId',
      ] },
      { accessor: 'match_id', name: 'match_capture_points_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_capture_points_capture_point_id_key', constraint: 'unique', columns: ['capturePointId'] },
    ],
  }, MatchCapturePointsRow),
  match_checkpoints: __table({
    name: 'match_checkpoints',
    indexes: [
      { accessor: 'match_id', name: 'match_checkpoints_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_checkpoints_match_id_key', constraint: 'unique', columns: ['matchId'] },
    ],
  }, MatchCheckpointsRow),
  match_economy: __table({
    name: 'match_economy',
    indexes: [
      { accessor: 'match_id', name: 'match_economy_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_economy_match_id_key', constraint: 'unique', columns: ['matchId'] },
    ],
  }, MatchEconomyRow),
  match_engagements: __table({
    name: 'match_engagements',
    indexes: [
      { accessor: 'id', name: 'match_engagements_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'match_id', name: 'match_engagements_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_engagements_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, MatchEngagementsRow),
  match_events: __table({
    name: 'match_events',
    indexes: [
      { accessor: 'match_id', name: 'match_events_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'row_id', name: 'match_events_row_id_idx_btree', algorithm: 'btree', columns: [
        'rowId',
      ] },
    ],
    constraints: [
      { name: 'match_events_row_id_key', constraint: 'unique', columns: ['rowId'] },
    ],
  }, MatchEventsRow),
  match_handoff_requests: __table({
    name: 'match_handoff_requests',
    indexes: [
      { accessor: 'match_id', name: 'match_handoff_requests_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_handoff_requests_match_id_key', constraint: 'unique', columns: ['matchId'] },
    ],
  }, MatchHandoffRequestsRow),
  match_host: __table({
    name: 'match_host',
    indexes: [
      { accessor: 'match_id', name: 'match_host_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_host_match_id_key', constraint: 'unique', columns: ['matchId'] },
    ],
  }, MatchHostRow),
  match_messengers: __table({
    name: 'match_messengers',
    indexes: [
      { accessor: 'id', name: 'match_messengers_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'match_id', name: 'match_messengers_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_messengers_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, MatchMessengersRow),
  match_projectiles: __table({
    name: 'match_projectiles',
    indexes: [
      { accessor: 'id', name: 'match_projectiles_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'match_id', name: 'match_projectiles_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_projectiles_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, MatchProjectilesRow),
  match_state: __table({
    name: 'match_state',
    indexes: [
      { accessor: 'match_id', name: 'match_state_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_state_match_id_key', constraint: 'unique', columns: ['matchId'] },
    ],
  }, MatchStateRow),
  match_structure_state: __table({
    name: 'match_structure_state',
    indexes: [
      { accessor: 'match_id', name: 'match_structure_state_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'structure_state_id', name: 'match_structure_state_structure_state_id_idx_btree', algorithm: 'btree', columns: [
        'structureStateId',
      ] },
    ],
    constraints: [
      { name: 'match_structure_state_structure_state_id_key', constraint: 'unique', columns: ['structureStateId'] },
    ],
  }, MatchStructureStateRow),
  match_terrain_overrides: __table({
    name: 'match_terrain_overrides',
    indexes: [
      { accessor: 'match_id', name: 'match_terrain_overrides_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_terrain_overrides_match_id_key', constraint: 'unique', columns: ['matchId'] },
    ],
  }, MatchTerrainOverridesRow),
  match_units: __table({
    name: 'match_units',
    indexes: [
      { accessor: 'id', name: 'match_units_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'match_id', name: 'match_units_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_units_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, MatchUnitsRow),
  match_wall_build_projects: __table({
    name: 'match_wall_build_projects',
    indexes: [
      { accessor: 'match_id', name: 'match_wall_build_projects_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'match_wall_build_projects_match_id_key', constraint: 'unique', columns: ['matchId'] },
    ],
  }, MatchWallBuildProjectsRow),
  match_worker_endpoints: __table({
    name: 'match_worker_endpoints',
    indexes: [
      { accessor: 'match_id', name: 'match_worker_endpoints_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'match_worker_endpoints_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'row_id', name: 'match_worker_endpoints_row_id_idx_btree', algorithm: 'btree', columns: [
        'rowId',
      ] },
    ],
    constraints: [
      { name: 'match_worker_endpoints_row_id_key', constraint: 'unique', columns: ['rowId'] },
    ],
  }, MatchWorkerEndpointsRow),
  matches: __table({
    name: 'matches',
    indexes: [
      { accessor: 'id', name: 'matches_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'mode', name: 'matches_mode_idx_btree', algorithm: 'btree', columns: [
        'mode',
      ] },
      { accessor: 'phase', name: 'matches_phase_idx_btree', algorithm: 'btree', columns: [
        'phase',
      ] },
      { accessor: 'ruleset', name: 'matches_ruleset_idx_btree', algorithm: 'btree', columns: [
        'ruleset',
      ] },
      { accessor: 'season', name: 'matches_season_idx_btree', algorithm: 'btree', columns: [
        'season',
      ] },
    ],
    constraints: [
      { name: 'matches_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, MatchesRow),
  module_admin: __table({
    name: 'module_admin',
    indexes: [
      { accessor: 'key', name: 'module_admin_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'module_admin_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, ModuleAdminRow),
  module_runtime_config: __table({
    name: 'module_runtime_config',
    indexes: [
      { accessor: 'id', name: 'module_runtime_config_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'module_runtime_config_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ModuleRuntimeConfigRow),
  orchestrator_identity: __table({
    name: 'orchestrator_identity',
    indexes: [
      { accessor: 'key', name: 'orchestrator_identity_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'orchestrator_identity_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, OrchestratorIdentityRow),
  pending_orders: __table({
    name: 'pending_orders',
    indexes: [
      { accessor: 'match_id', name: 'pending_orders_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'row_id', name: 'pending_orders_row_id_idx_btree', algorithm: 'btree', columns: [
        'rowId',
      ] },
    ],
    constraints: [
      { name: 'pending_orders_row_id_key', constraint: 'unique', columns: ['rowId'] },
    ],
  }, PendingOrdersRow),
  player_match_follow_waypoints: __table({
    name: 'player_match_follow_waypoints',
    indexes: [
      { accessor: 'match_id', name: 'player_match_follow_waypoints_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'player_match_follow_waypoints_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'waypoint_id', name: 'player_match_follow_waypoints_waypoint_id_idx_btree', algorithm: 'btree', columns: [
        'waypointId',
      ] },
    ],
    constraints: [
      { name: 'player_match_follow_waypoints_waypoint_id_key', constraint: 'unique', columns: ['waypointId'] },
    ],
  }, PlayerMatchFollowWaypointsRow),
  player_match_meta: __table({
    name: 'player_match_meta',
    indexes: [
      { accessor: 'match_id', name: 'player_match_meta_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'player_match_meta_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'snapshot_id', name: 'player_match_meta_snapshot_id_idx_btree', algorithm: 'btree', columns: [
        'snapshotId',
      ] },
    ],
    constraints: [
      { name: 'player_match_meta_snapshot_id_key', constraint: 'unique', columns: ['snapshotId'] },
    ],
  }, PlayerMatchMetaRow),
  player_match_roads: __table({
    name: 'player_match_roads',
    indexes: [
      { accessor: 'match_id', name: 'player_match_roads_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'player_match_roads_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'snapshot_id', name: 'player_match_roads_snapshot_id_idx_btree', algorithm: 'btree', columns: [
        'snapshotId',
      ] },
    ],
    constraints: [
      { name: 'player_match_roads_snapshot_id_key', constraint: 'unique', columns: ['snapshotId'] },
    ],
  }, PlayerMatchRoadsRow),
  player_visibility_bitmaps: __table({
    name: 'player_visibility_bitmaps',
    indexes: [
      { accessor: 'bitmap_id', name: 'player_visibility_bitmaps_bitmap_id_idx_btree', algorithm: 'btree', columns: [
        'bitmapId',
      ] },
      { accessor: 'match_id', name: 'player_visibility_bitmaps_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'player_visibility_bitmaps_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
    ],
    constraints: [
      { name: 'player_visibility_bitmaps_bitmap_id_key', constraint: 'unique', columns: ['bitmapId'] },
    ],
  }, PlayerVisibilityBitmapsRow),
  player_visible_enemy_units: __table({
    name: 'player_visible_enemy_units',
    indexes: [
      { accessor: 'match_id', name: 'player_visible_enemy_units_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'player_visible_enemy_units_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'visible_unit_id', name: 'player_visible_enemy_units_visible_unit_id_idx_btree', algorithm: 'btree', columns: [
        'visibleUnitId',
      ] },
    ],
    constraints: [
      { name: 'player_visible_enemy_units_visible_unit_id_key', constraint: 'unique', columns: ['visibleUnitId'] },
    ],
  }, PlayerVisibleEnemyUnitsRow),
  player_visible_engagements: __table({
    name: 'player_visible_engagements',
    indexes: [
      { accessor: 'match_id', name: 'player_visible_engagements_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'player_visible_engagements_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'visible_engagement_id', name: 'player_visible_engagements_visible_engagement_id_idx_btree', algorithm: 'btree', columns: [
        'visibleEngagementId',
      ] },
    ],
    constraints: [
      { name: 'player_visible_engagements_visible_engagement_id_key', constraint: 'unique', columns: ['visibleEngagementId'] },
    ],
  }, PlayerVisibleEngagementsRow),
  player_visible_friendly_units: __table({
    name: 'player_visible_friendly_units',
    indexes: [
      { accessor: 'match_id', name: 'player_visible_friendly_units_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'player_visible_friendly_units_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'visible_unit_id', name: 'player_visible_friendly_units_visible_unit_id_idx_btree', algorithm: 'btree', columns: [
        'visibleUnitId',
      ] },
    ],
    constraints: [
      { name: 'player_visible_friendly_units_visible_unit_id_key', constraint: 'unique', columns: ['visibleUnitId'] },
    ],
  }, PlayerVisibleFriendlyUnitsRow),
  player_visible_messengers: __table({
    name: 'player_visible_messengers',
    indexes: [
      { accessor: 'match_id', name: 'player_visible_messengers_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'player_visible_messengers_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'visible_messenger_id', name: 'player_visible_messengers_visible_messenger_id_idx_btree', algorithm: 'btree', columns: [
        'visibleMessengerId',
      ] },
    ],
    constraints: [
      { name: 'player_visible_messengers_visible_messenger_id_key', constraint: 'unique', columns: ['visibleMessengerId'] },
    ],
  }, PlayerVisibleMessengersRow),
  player_visible_projectiles: __table({
    name: 'player_visible_projectiles',
    indexes: [
      { accessor: 'match_id', name: 'player_visible_projectiles_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'player_visible_projectiles_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'visible_projectile_id', name: 'player_visible_projectiles_visible_projectile_id_idx_btree', algorithm: 'btree', columns: [
        'visibleProjectileId',
      ] },
    ],
    constraints: [
      { name: 'player_visible_projectiles_visible_projectile_id_key', constraint: 'unique', columns: ['visibleProjectileId'] },
    ],
  }, PlayerVisibleProjectilesRow),
  player_visible_projectiles_v2: __table({
    name: 'player_visible_projectiles_v_2',
    indexes: [
      { accessor: 'match_id', name: 'player_visible_projectiles_v_2_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'player_visible_projectiles_v_2_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'visible_projectile_id', name: 'player_visible_projectiles_v_2_visible_projectile_id_idx_btree', algorithm: 'btree', columns: [
        'visibleProjectileId',
      ] },
    ],
    constraints: [
      { name: 'player_visible_projectiles_v_2_visible_projectile_id_key', constraint: 'unique', columns: ['visibleProjectileId'] },
    ],
  }, PlayerVisibleProjectilesV2Row),
  player_visible_projectiles_v3: __table({
    name: 'player_visible_projectiles_v_3',
    indexes: [
      { accessor: 'match_id', name: 'player_visible_projectiles_v_3_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'player_visible_projectiles_v_3_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'visible_projectile_id', name: 'player_visible_projectiles_v_3_visible_projectile_id_idx_btree', algorithm: 'btree', columns: [
        'visibleProjectileId',
      ] },
    ],
    constraints: [
      { name: 'player_visible_projectiles_v_3_visible_projectile_id_key', constraint: 'unique', columns: ['visibleProjectileId'] },
    ],
  }, PlayerVisibleProjectilesV3Row),
  player_visible_unit_order_queue: __table({
    name: 'player_visible_unit_order_queue',
    indexes: [
      { accessor: 'match_id', name: 'player_visible_unit_order_queue_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'order_row_id', name: 'player_visible_unit_order_queue_order_row_id_idx_btree', algorithm: 'btree', columns: [
        'orderRowId',
      ] },
      { accessor: 'player_id', name: 'player_visible_unit_order_queue_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
    ],
    constraints: [
      { name: 'player_visible_unit_order_queue_order_row_id_key', constraint: 'unique', columns: ['orderRowId'] },
    ],
  }, PlayerVisibleUnitOrderQueueRow),
  player_visible_unit_path_waypoints: __table({
    name: 'player_visible_unit_path_waypoints',
    indexes: [
      { accessor: 'match_id', name: 'player_visible_unit_path_waypoints_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'player_visible_unit_path_waypoints_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'waypoint_id', name: 'player_visible_unit_path_waypoints_waypoint_id_idx_btree', algorithm: 'btree', columns: [
        'waypointId',
      ] },
    ],
    constraints: [
      { name: 'player_visible_unit_path_waypoints_waypoint_id_key', constraint: 'unique', columns: ['waypointId'] },
    ],
  }, PlayerVisibleUnitPathWaypointsRow),
  player_visible_unit_skills: __table({
    name: 'player_visible_unit_skills',
    indexes: [
      { accessor: 'match_id', name: 'player_visible_unit_skills_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'player_id', name: 'player_visible_unit_skills_player_id_idx_btree', algorithm: 'btree', columns: [
        'playerId',
      ] },
      { accessor: 'skill_id', name: 'player_visible_unit_skills_skill_id_idx_btree', algorithm: 'btree', columns: [
        'skillId',
      ] },
    ],
    constraints: [
      { name: 'player_visible_unit_skills_skill_id_key', constraint: 'unique', columns: ['skillId'] },
    ],
  }, PlayerVisibleUnitSkillsRow),
  players: __table({
    name: 'players',
    indexes: [
      { accessor: 'id', name: 'players_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'players_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, PlayersRow),
  standalone_start_packets: __table({
    name: 'standalone_start_packets',
    indexes: [
      { accessor: 'host_player_id', name: 'standalone_start_packets_host_player_id_idx_btree', algorithm: 'btree', columns: [
        'hostPlayerId',
      ] },
      { accessor: 'match_id', name: 'standalone_start_packets_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'standalone_start_packets_match_id_key', constraint: 'unique', columns: ['matchId'] },
    ],
  }, StandaloneStartPacketsRow),
  tick_schedule: __table({
    name: 'tick_schedule',
    indexes: [
      { accessor: 'scheduled_id', name: 'tick_schedule_scheduled_id_idx_btree', algorithm: 'btree', columns: [
        'scheduledId',
      ] },
    ],
    constraints: [
      { name: 'tick_schedule_scheduled_id_key', constraint: 'unique', columns: ['scheduledId'] },
    ],
  }, TickScheduleRow),
  awe_host_commands: __table({
    name: 'awe_host_commands',
    indexes: [
    ],
    constraints: [
    ],
  }, AweHostCommandsRow),
  awe_host_factions: __table({
    name: 'awe_host_factions',
    indexes: [
    ],
    constraints: [
    ],
  }, AweHostFactionsRow),
  awe_host_territory: __table({
    name: 'awe_host_territory',
    indexes: [
    ],
    constraints: [
    ],
  }, AweHostTerritoryRow),
  awe_host_world: __table({
    name: 'awe_host_world',
    indexes: [
    ],
    constraints: [
    ],
  }, AweHostWorldRow),
  global_world_status: __table({
    name: 'global_world_status',
    indexes: [
    ],
    constraints: [
    ],
  }, GlobalWorldStatusRow),
  my_armies: __table({
    name: 'my_armies',
    indexes: [
    ],
    constraints: [
    ],
  }, MyArmiesRow),
  my_army_formations: __table({
    name: 'my_army_formations',
    indexes: [
    ],
    constraints: [
    ],
  }, MyArmyFormationsRow),
  my_army_groups: __table({
    name: 'my_army_groups',
    indexes: [
    ],
    constraints: [
    ],
  }, MyArmyGroupsRow),
  my_army_units: __table({
    name: 'my_army_units',
    indexes: [
    ],
    constraints: [
    ],
  }, MyArmyUnitsRow),
  my_campaign_army: __table({
    name: 'my_campaign_army',
    indexes: [
    ],
    constraints: [
    ],
  }, MyCampaignArmyRow),
  my_campaign_player: __table({
    name: 'my_campaign_player',
    indexes: [
    ],
    constraints: [
    ],
  }, MyCampaignPlayerRow),
  my_campaign_recruitment: __table({
    name: 'my_campaign_recruitment',
    indexes: [
    ],
    constraints: [
    ],
  }, MyCampaignRecruitmentRow),
  my_campaign_resources: __table({
    name: 'my_campaign_resources',
    indexes: [
    ],
    constraints: [
    ],
  }, MyCampaignResourcesRow),
  my_conquest_challenges: __table({
    name: 'my_conquest_challenges',
    indexes: [
    ],
    constraints: [
    ],
  }, MyConquestChallengesRow),
  my_conquest_custom_unit_templates: __table({
    name: 'my_conquest_custom_unit_templates',
    indexes: [
    ],
    constraints: [
    ],
  }, MyConquestCustomUnitTemplatesRow),
  my_conquest_events: __table({
    name: 'my_conquest_events',
    indexes: [
    ],
    constraints: [
    ],
  }, MyConquestEventsRow),
  my_conquest_profiles: __table({
    name: 'my_conquest_profiles',
    indexes: [
    ],
    constraints: [
    ],
  }, MyConquestProfilesRow),
  my_conquest_profiles_v2: __table({
    name: 'my_conquest_profiles_v_2',
    indexes: [
    ],
    constraints: [
    ],
  }, MyConquestProfilesV2Row),
  my_conquest_queue: __table({
    name: 'my_conquest_queue',
    indexes: [
    ],
    constraints: [
    ],
  }, MyConquestQueueRow),
  my_conquest_saved_units: __table({
    name: 'my_conquest_saved_units',
    indexes: [
    ],
    constraints: [
    ],
  }, MyConquestSavedUnitsRow),
  my_conquest_territories: __table({
    name: 'my_conquest_territories',
    indexes: [
    ],
    constraints: [
    ],
  }, MyConquestTerritoriesRow),
  my_enemy_units: __table({
    name: 'my_enemy_units',
    indexes: [
    ],
    constraints: [
    ],
  }, MyEnemyUnitsRow),
  my_engagements: __table({
    name: 'my_engagements',
    indexes: [
    ],
    constraints: [
    ],
  }, MyEngagementsRow),
  my_friendly_units: __table({
    name: 'my_friendly_units',
    indexes: [
    ],
    constraints: [
    ],
  }, MyFriendlyUnitsRow),
  my_global_faction: __table({
    name: 'my_global_faction',
    indexes: [
    ],
    constraints: [
    ],
  }, MyGlobalFactionRow),
  my_global_results: __table({
    name: 'my_global_results',
    indexes: [
    ],
    constraints: [
    ],
  }, MyGlobalResultsRow),
  my_global_rosters: __table({
    name: 'my_global_rosters',
    indexes: [
    ],
    constraints: [
    ],
  }, MyGlobalRostersRow),
  my_match_follow_waypoints: __table({
    name: 'my_match_follow_waypoints',
    indexes: [
    ],
    constraints: [
    ],
  }, MyMatchFollowWaypointsRow),
  my_match_meta: __table({
    name: 'my_match_meta',
    indexes: [
    ],
    constraints: [
    ],
  }, MyMatchMetaRow),
  my_match_roads: __table({
    name: 'my_match_roads',
    indexes: [
    ],
    constraints: [
    ],
  }, MyMatchRoadsRow),
  my_match_worker_endpoint: __table({
    name: 'my_match_worker_endpoint',
    indexes: [
    ],
    constraints: [
    ],
  }, MyMatchWorkerEndpointRow),
  my_messengers: __table({
    name: 'my_messengers',
    indexes: [
    ],
    constraints: [
    ],
  }, MyMessengersRow),
  my_projectiles: __table({
    name: 'my_projectiles',
    indexes: [
    ],
    constraints: [
    ],
  }, MyProjectilesRow),
  my_session: __table({
    name: 'my_session',
    indexes: [
    ],
    constraints: [
    ],
  }, MySessionRow),
  my_standalone_start_packet: __table({
    name: 'my_standalone_start_packet',
    indexes: [
    ],
    constraints: [
    ],
  }, MyStandaloneStartPacketRow),
  my_unit_order_queue: __table({
    name: 'my_unit_order_queue',
    indexes: [
    ],
    constraints: [
    ],
  }, MyUnitOrderQueueRow),
  my_unit_path_waypoints: __table({
    name: 'my_unit_path_waypoints',
    indexes: [
    ],
    constraints: [
    ],
  }, MyUnitPathWaypointsRow),
  my_unit_skills: __table({
    name: 'my_unit_skills',
    indexes: [
    ],
    constraints: [
    ],
  }, MyUnitSkillsRow),
  my_visibility_bitmap: __table({
    name: 'my_visibility_bitmap',
    indexes: [
    ],
    constraints: [
    ],
  }, MyVisibilityBitmapRow),
  skirmish_lobby_matches: __table({
    name: 'skirmish_lobby_matches',
    indexes: [
    ],
    constraints: [
    ],
  }, SkirmishLobbyMatchesRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("abandon_arena_match", AbandonArenaMatchReducer),
  __reducerSchema("acquire_global_world", AcquireGlobalWorldReducer),
  __reducerSchema("add_bot_to_match", AddBotToMatchReducer),
  __reducerSchema("arena_matchmaking_timeout", ArenaMatchmakingTimeoutReducer),
  __reducerSchema("awe_ack_commands", AweAckCommandsReducer),
  __reducerSchema("awe_claim_army", AweClaimArmyReducer),
  __reducerSchema("awe_close_campaign", AweCloseCampaignReducer),
  __reducerSchema("awe_create_campaign", AweCreateCampaignReducer),
  __reducerSchema("awe_delete_campaign", AweDeleteCampaignReducer),
  __reducerSchema("awe_deploy_army", AweDeployArmyReducer),
  __reducerSchema("awe_join_grant", AweJoinGrantReducer),
  __reducerSchema("awe_order_army", AweOrderArmyReducer),
  __reducerSchema("awe_set_host", AweSetHostReducer),
  __reducerSchema("awe_set_steam_lobby", AweSetSteamLobbyReducer),
  __reducerSchema("awe_update_rules", AweUpdateRulesReducer),
  __reducerSchema("cancel_messenger", CancelMessengerReducer),
  __reducerSchema("cancel_wall_build_project", CancelWallBuildProjectReducer),
  __reducerSchema("choose_conquest_starter", ChooseConquestStarterReducer),
  __reducerSchema("claim_match_host", ClaimMatchHostReducer),
  __reducerSchema("claim_orchestrator_identity", ClaimOrchestratorIdentityReducer),
  __reducerSchema("claim_recruited_units", ClaimRecruitedUnitsReducer),
  __reducerSchema("cleanup_stale_lobbies", CleanupStaleLobbiesReducer),
  __reducerSchema("clear_auth", ClearAuthReducer),
  __reducerSchema("commit_global_world", CommitGlobalWorldReducer),
  __reducerSchema("create_conquest_custom_unit_template", CreateConquestCustomUnitTemplateReducer),
  __reducerSchema("create_global_starter_roster", CreateGlobalStarterRosterReducer),
  __reducerSchema("create_match", CreateMatchReducer),
  __reducerSchema("delete_conquest_custom_unit_template", DeleteConquestCustomUnitTemplateReducer),
  __reducerSchema("delete_formation", DeleteFormationReducer),
  __reducerSchema("delete_group", DeleteGroupReducer),
  __reducerSchema("delete_map", DeleteMapReducer),
  __reducerSchema("deploy_global_army", DeployGlobalArmyReducer),
  __reducerSchema("deploy_global_starter", DeployGlobalStarterReducer),
  __reducerSchema("deploy_units", DeployUnitsReducer),
  __reducerSchema("designate_harvest_tile", DesignateHarvestTileReducer),
  __reducerSchema("dispatch_order", DispatchOrderReducer),
  __reducerSchema("enter_arena_queue", EnterArenaQueueReducer),
  __reducerSchema("expire_global_lease", ExpireGlobalLeaseReducer),
  __reducerSchema("form_up", FormUpReducer),
  __reducerSchema("group_order", GroupOrderReducer),
  __reducerSchema("join_campaign_world", JoinCampaignWorldReducer),
  __reducerSchema("join_conquest", JoinConquestReducer),
  __reducerSchema("join_conquest_queue", JoinConquestQueueReducer),
  __reducerSchema("join_global_world", JoinGlobalWorldReducer),
  __reducerSchema("join_match", JoinMatchReducer),
  __reducerSchema("leave_arena_queue", LeaveArenaQueueReducer),
  __reducerSchema("leave_conquest_queue", LeaveConquestQueueReducer),
  __reducerSchema("leave_match", LeaveMatchReducer),
  __reducerSchema("order_follow", OrderFollowReducer),
  __reducerSchema("order_global_units", OrderGlobalUnitsReducer),
  __reducerSchema("present_auth_token", PresentAuthTokenReducer),
  __reducerSchema("process_campaign_tick", ProcessCampaignTickReducer),
  __reducerSchema("process_conquest_lobby_timer", ProcessConquestLobbyTimerReducer),
  __reducerSchema("process_tick", ProcessTickReducer),
  __reducerSchema("queue_orders", QueueOrdersReducer),
  __reducerSchema("ready", ReadyReducer),
  __reducerSchema("recruit_campaign_units", RecruitCampaignUnitsReducer),
  __reducerSchema("register_global_campaign", RegisterGlobalCampaignReducer),
  __reducerSchema("register_map", RegisterMapReducer),
  __reducerSchema("register_map_chunk", RegisterMapChunkReducer),
  __reducerSchema("register_match_worker", RegisterMatchWorkerReducer),
  __reducerSchema("renew_global_world", RenewGlobalWorldReducer),
  __reducerSchema("reset_conquest_custom_unit_template", ResetConquestCustomUnitTemplateReducer),
  __reducerSchema("save_conquest_battle_units", SaveConquestBattleUnitsReducer),
  __reducerSchema("save_conquest_custom_unit_template", SaveConquestCustomUnitTemplateReducer),
  __reducerSchema("save_formation", SaveFormationReducer),
  __reducerSchema("save_march_order", SaveMarchOrderReducer),
  __reducerSchema("select_roster", SelectRosterReducer),
  __reducerSchema("set_army_color", SetArmyColorReducer),
  __reducerSchema("set_army_culture", SetArmyCultureReducer),
  __reducerSchema("set_campaign_army_destination", SetCampaignArmyDestinationReducer),
  __reducerSchema("set_conquest_army_banner", SetConquestArmyBannerReducer),
  __reducerSchema("set_conquest_army_marker", SetConquestArmyMarkerReducer),
  __reducerSchema("set_conquest_culture", SetConquestCultureReducer),
  __reducerSchema("set_formation_shape", SetFormationShapeReducer),
  __reducerSchema("set_group", SetGroupReducer),
  __reducerSchema("set_map_active", SetMapActiveReducer),
  __reducerSchema("set_name", SetNameReducer),
  __reducerSchema("set_orchestrator_identity", SetOrchestratorIdentityReducer),
  __reducerSchema("set_simulation_disabled", SetSimulationDisabledReducer),
  __reducerSchema("start_match", StartMatchReducer),
  __reducerSchema("submit_match_result", SubmitMatchResultReducer),
  __reducerSchema("test_start_match", TestStartMatchReducer),
  __reducerSchema("toggle_gate", ToggleGateReducer),
  __reducerSchema("undesignate_harvest_tile", UndesignateHarvestTileReducer),
  __reducerSchema("update_conquest_custom_unit_template", UpdateConquestCustomUnitTemplateReducer),
  __reducerSchema("update_formation", UpdateFormationReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.1.0" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

